export const GET_TIMEZONES_START = 'GET_TIMEZONES_START';
export const GET_TIMEZONES_SUCCESS = 'GET_TIMEZONES_SUCCESS';
export const GET_TIMEZONES_FAIL = 'GET_TIMEZONES_FAIL';

export const GET_TIMEZONE_START = 'GET_TIMEZONE_START';
export const GET_TIMEZONE_SUCCESS = 'GET_TIMEZONE_SUCCESS';
export const GET_TIMEZONE_FAIL = 'GET_TIMEZONE_FAIL';
